const styles = {
  page_header: {
    fontSize: 30,
    color: '#666',
    marginBottom: 50
  },
  page_text: {
    fontSize: 14,
    color: '#666',
    fontWeight: '100',
    lineHeight: 21
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/comp/pages/style.js